import React from 'react';
import clsx from 'clsx';

interface PageFormWrapperProps {
  title?: string;
  children: React.ReactNode;
  maxWidth?: string; // Ej: 'max-w-4xl', 'max-w-6xl'
}

const PageFormWrapper: React.FC<PageFormWrapperProps> = ({
  title,
  children,
  maxWidth = 'max-w-6xl',
}) => {
  return (
    <div
      className={clsx(
        'w-full rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark mt-6',
        maxWidth
      )}
    >
      {title && (
        <div className="border-b border-stroke py-4 px-6.5 dark:border-strokedark">
          <h3 className="font-medium text-black dark:text-white">{title}</h3>
        </div>
      )}
      <div className="p-6.5">{children}</div>
    </div>
  );
};

export default PageFormWrapper;
